<template>
  <div class="teamFilterCheckboxes">
      <h3>Filter By Event Type</h3>
        <label v-for="category in eventCategories" class="teamFilterCheckbox">
            <input type="radio"
                    name="eventFilter"
                    :value="category.id"
                    @change="update"
                    v-model="checkedCategory">
            <div>{{ category.title }}</div>
        </label>
        <label class="teamFilterCheckbox">
            <input type="radio"
                    name="eventFilter"
                    value="0"
                    @change="update"
                    v-model="checkedCategory">
            <div>All Events</div>
        </label>
  </div>
</template>

<script>
export default {

  data() {
    return {
      checkedCategory: 0,
    }
  },
  props: {
      eventCategories: {
        required: true,
        type: Array
      },
      initialCategory: {},
    },
  watch: {
    initialCategory(val) {
     this.checkedCategory = val;
    }
  },
  methods: {
    update() {
      this.$emit('updateCategory',this.checkedCategory);
    }
  }

}
</script>

